import DashboardLayout from '../layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../pages/NotFoundPage.vue'
import SignIn from 'src/pages/SignIn.vue'

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/admin/websites'
  },
  {
    path: "/sign-in",
    component: SignIn,
  },
  {
    path: '/site-editor/:id',
    component: () => import(
      /* webpackPrefetch: true */
      '../pages/site-editor/site-editor.vue'
      ),
    redirect: '/site-editor/:id/landing-page',
    children: [
      {
        path: 'landing-page',
        name: 'Editor Landing Page',
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/site-editor/landing-page.vue'
          ),
      },
      {
        path: 'catalog',
        name: 'Editor Catalog',
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/site-editor/catalog.vue'
          ),
      },
      {
        path: 'contact',
        name: 'Editor Contact',
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/site-editor/contact.vue'
          ),
      },
      {
        path: 'pages',
        name: 'Pages',
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/site-editor/pages.vue'
          ),
      },
      {
        path: '404',
        name: '404 Pages',
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/site-editor/404.vue'
          ),
      },
      {
        path: 'email-templates',
        name: 'Email templates',
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/site-editor/email-templates.vue'
          ),
      },
      {
        path: 'physical-shops',
        name: 'Physical Shops',
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/site-editor/physical-shops.vue'
          ),
      },
      {
        path: 'authentication',
        name: 'Authentication',
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/site-editor/authentication.vue'
          ),
      },
      {
        path: 'account',
        name: 'Account',
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/site-editor/account.vue'
          ),
      },
      {
        path: 'checkout',
        name: 'Checkout',
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/site-editor/checkout.vue'
          ),
      },

      {
        path: 'css-grid',
        name: 'Css Grid demo',
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/site-editor/css-grid.vue'
          ),
      },
    ],
  },
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/websites',
    children: [
      {
        path: 'websites',
        name: 'Websites',
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/Websites.vue'
          ),
      },
      {
        path: 'synonyms',
        name: 'Synonyms',
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/Synonyms.vue'
          ),
      },
      {
        path: 'discounts',
        name: 'Discounts',
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/Discounts.vue'
          ),
      },
      {
        path: 'audit-page',
        name: 'Audit Page',
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/AuditPage.vue'
          ),
      },
      {
        path: 'editor-packages',
        name: 'Editor Packages',
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/EditorPackages.vue'
          ),
      },
      {
        path: "customer-overview",
        name: "Customer overview",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/CustomerOverview.vue'
          )
      },
      {
        path: "categories",
        name: "Categories",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/Categories.vue'
          ),
      },
      {
        path: 'websites/new',
        name: 'New website',
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/websites/ManageWebsite.vue'
          )
      },
      {
        path: 'websites/edit/:id',
        name: "Edit website",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/websites/ManageWebsite.vue'
          )
      },
      {
        path: 'websites/cms/:id/:cmstype/:section',
        name: "CMS website",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/websites/CmsWebsite.vue'
          )
      },
      {
        path: "accounts",
        name: "Accounts",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/Accounts.vue'
          ),
      },
      /* {
        path: "categories",
        name: "Categories",
        component: () => import(
          '../pages/Categories.vue'
        ),
      }, */
      {
        path: "brands",
        name: "",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/Brands.vue'
          ),
      },
      {
        path: "suppliers",
        name: "",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/Suppliers.vue'
          ),
      },
      {
        path: "product-settings",
        name: "",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/SupplierProductSettings.vue'
          ),
      },
      {
        path: "supplier-orders",
        name: "",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/SupplierOrders.vue'
          ),
      },
      {
        path: "supplier-orders/:id",
        name: "",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/SupplierOrdersDetail.vue'
          ),
      },
      {
        path: "all-products",
        name: "alle producten",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/products/AllProducts.vue'
          ),
      },
      {
        path: "shop-stocks",
        name: "winkel voorraad",
        component: () => import(
          '../pages/ShopStocks.vue'
          ),
      },
      {
        path: "catalog",
        name: "catalog",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/catalogs/List.vue'
        ),
      },
      {
        path: "advice-order",
        name: "Advice order",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/AdviceOrderNew.vue'
          ),
      },
      {
        path: "attributes",
        name: "Attributen",
        component: () => import(
          '../pages/ConfigurableProduct.vue'
          )
      },
      {
        path: "wholesale-orders",
        name: "Wholesale orders",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/WholesaleOrders.vue'
          ),
      },
      {
        path: "wholesale-order/new",
        name: "New wholesale orders",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/overview-order-view/EditWholesaleOrder.vue'
          ),
      },
      {
        path: "wholesale-orders/:id",
        name: "view overview order",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/overview-order-view/EditWholesaleOrder.vue'
          )
      },
      {
        path: "overview-order",
        name: "overview order",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/OverviewOrder.vue'
          ),
      },
      {
        path: "marketing",
        name: "Marketing",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/Marketing.vue'
          ),
      },
      {
        path: "replenishment",
        name: "replenishment",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/Replenishment.vue'
          ),
      },
      {
        path: "order/:id",
        name: "view overview order",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/overview-order-view/OverviewOrderView.vue'
          )
      },
      {
        path: "product/new",
        name: "New product",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/products/ManageProduct.vue'
          )
      },
      {
        path: "product/edit/:id",
        name: "Edit product",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/products/ManageProduct.vue'
          )
      },
      {
        path: "product/copy/:id",
        name: "Copy Product",
        component: () => import(
          '../pages/products/ManageProduct.vue'
          )
      },
      {
        path: "advice-order-new",
        name: "Advice order new",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/AdviceOrderNew.vue'
          ),
      },
      {
        path: "overwrite-product/:id",
        name: "Overwrite product",
        routerEnter: (to, from, next) => to.query.website ? next() : next(`/admin/website-products`),
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/products/ManageProduct.vue'
          )
      },
    ]
  },
  { path: '*', component: NotFound }
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes
